<template>
  <div class="container setting-page">
    <ul class="nav nav-tabs nav-fill nav-tabs-sm">
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{'active': activeTab === 'dashboard'}"
          @click="changeTabs('dashboard')"
        >
          {{ $t("Setting.Tabs.Dashboard") }}
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{'active': activeTab === 'user'}"
          @click="changeTabs('user')"
        >
          {{ $t("Setting.Tabs.User") }}
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{'active': activeTab === 'customer'}"
          @click="changeTabs('customer')"
        >
          {{ $t("Setting.Tabs.Customer") }}
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{'active': activeTab === 'licence'}"
          @click="changeTabs('licence')"
        >
          {{ $t("Setting.Tabs.License") }}
        </a>
      </li>
    </ul>

    <div class="tab-contents">
      <div v-show="activeTab === 'dashboard'">
        <dashboard
          :dashboard-data="dashboardDataArray"
          page-type="adminSetting"
        />
      </div>

      <div v-show="activeTab === 'user'">
        <user-setting
          :user-data="userSettingData"
        />
      </div>

      <div v-show="activeTab === 'customer'">
        <customer-setting />
      </div>

      <div v-show="activeTab === 'licence'">
        <license-setting />
      </div>
    </div>
  </div>
</template>

<script>
import Dashboard from '../SmartScheduling/components/Dashboard.vue'
import UserSetting from './components/UserSetting.vue'
import CustomerSetting from './components/CustomerSetting.vue'
import LicenseSetting from './components/LicenseSetting.vue'

import { mapState, mapActions } from 'vuex'

export default {
  title: 'Setting',
  components: {
    Dashboard,
    UserSetting,
    CustomerSetting,
    LicenseSetting,
  },
  data: () => ({
    activeTab: 'dashboard',
    dashboardDataArray: []
  }),
  computed: {
    ...mapState('auth', [
      'uid',
    ]),
    ...mapState('scheduling', [
      'dashboardData',
      'userSettingData'
    ]),
  },
  mounted() {
    // NOTE: Load setting datas
    this.setLoadingState('loadSettingData')
    Promise.all([
      this.loadDashboard(this.uid),
      this.loadUserList(this.uid),
      this.loadCustomerSetting(this.uid),
      this.loadLicenseList(this.uid)
    ]).finally(() => {
      this.unsetLoadingState('loadSettingData')
    })
  },
  watch: {
    dashboardData: {
      handler: function (val, _) {
        console.log('changed')
        this.dashboardDataArray = [].concat(val)
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'setLoadingState',
      'unsetLoadingState'
    ]),
    ...mapActions('scheduling', [
      'loadDashboard',
      'loadUserList'
    ]),
    ...mapActions('auth', [
      'loadCustomerSetting',
      'loadLicenseList'
    ]),
    changeTabs (target) {
      this.activeTab = target
    },
  }
}
</script>

<style scoped>
.setting-page {
  width: 70vw;
  max-width: 1260px;
  background-color: white;
}

.tab-contents {
  padding: 24px 12px;
}

</style>
